import { useTranslation } from 'react-i18next';
import { skyLightest } from '../../styles/design-tokens';
import { Tooltip } from '../../ui-library/tooltip/tooltip';
import { SmallSquareButton } from '../small-square-button/small-square-button';

type Props = {
  onClick: () => void;
  visible?: boolean;
};

export const SelectAllButton = ({ onClick, visible = true }: Props) => {
  const i18n = useTranslation();
  if (!visible) {
    return null;
  }

  return (
    <Tooltip variant="white" label={i18n.t('common.labels.select_all')} position="left">
      <SmallSquareButton
        onClick={onClick}
        iconName="select_all"
        style={{ backgroundColor: skyLightest, position: 'absolute', bottom: 0, right: 32 }}
        aria-label="Select all"
      />
    </Tooltip>
  );
};
